<template>
    <li v-if="listItem" class="ui-dialog__alert-list-item" v-html="parsedError" />
    <div v-else class="ui-dialog__alert alert--error">
        <img
            class="ui-dialog__alert-image"
            src="/images/default/error.png"
            alt="error"
        />
        <div class="ui-dialog__alert-text" v-html="parsedError" />
    </div>

</template>

<script>
    import { _T } from '../globals';
    import escapeHtml from '../helpers/escape-html';

    export default {
        props: ['error', 'listItem'],
        computed: {
            // Rendered with v-html so anchors coming from the translation
            // template (product copy) become real links. User-provided params
            // are escaped first so a malicious value (e.g. a release title)
            // cannot inject markup. See PREDEV-6158.
            parsedError() {
                return _T(this.error.message, this.escapeParams(this.error.params));
            }
        },
        methods: {
            escapeParams(params) {
                if (Array.isArray(params)) {
                    return params.map(escapeHtml);
                }

                if (params && typeof params === 'object') {
                    return Object.keys(params).reduce((escaped, key) => {
                        escaped[key] = escapeHtml(params[key]);

                        return escaped;
                    }, {});
                }

                if (typeof params === 'string') {
                    return escapeHtml(params);
                }

                return params;
            }
        }
    };
</script>

<style lang="scss">
    .ui-dialog__alert {
        &:last-child {
            margin-bottom: 0;
        }
    }
</style>
